import React, { useState } from "react";
import {
  Box,
  Grid,
  Select,
  TextInput,
  NumberInput,
  Textarea,
  Text,
  Group,
  Accordion,
  ChevronIcon,
  Flex,
  UnstyledButton,
  ActionIcon,
  Popover,
  Paper,
  Stack,
  Button,
} from "@mantine/core";
import { DatePickerInput, DateInput } from "@mantine/dates";
import { IoCalendarClearOutline } from "react-icons/io5";
import { rem } from "@mantine/core";
import { DropDownArrowSvg } from "../../Svgs/DropDownArrowSvg";
import { useServicePlanStyles } from "../style";
import { IconChevronDown } from "@tabler/icons-react";
import moment from "moment";
import { careLevelOptions } from "../../PatientModal/HealthForm";
import { IoIosClose } from "react-icons/io";
import { FaPlus } from "react-icons/fa6";
import { useDisclosure } from "@mantine/hooks";
import BillingSearchBar from "../../Document/BillingSearchBar";
import { getdiagnosiscode } from "../../../services/servicecode";
import { useSelector } from "react-redux";
import { showError } from "../../../utils";

const ClientDataStep = ({ data, onChange, view, errors, selectedFacility }) => {
  const [
    diagPopoverOpened,
    { open: diagPopoverOpen, close: diagPopoverClose },
  ] = useDisclosure(false);
  const [diagnosisField, setDiagnosisField] = useState({
    code: "",
    name: "",
  });
  const alldiagnosiscode = useSelector(
    (state) => state.servicecode.alldiagnosisCode,
  );
  const [diagnosisSearchValue, setDiagnosisSearchValue] = useState("");
  const [
    allergyPopoverOpened,
    { open: allergyPopoverOpen, close: allergyPopoverClose },
  ] = useDisclosure(false);
  const [allergyValue, setAllergyValue] = useState("");

  const { classes } = useServicePlanStyles();

  const handleChange = (field, value) => {
    onChange({
      ...data,
      [field]: value,
    });
  };

  const handleChangeDiagnosis = () => {
    if (!diagnosisField.code || !diagnosisField.name) {
      showError("Missing or empty fields", 400);
      return;
    }

    const newDiagnosis = {
      code: diagnosisField.code,
      name: diagnosisField.name,
    };

    handleChange("diagnosis", [...data?.diagnosis, newDiagnosis]);
    setDiagnosisField({
      code: "",
      name: "",
    });
    setDiagnosisSearchValue("");
    diagPopoverClose();
  };

  const handleRemoveDiagnosis = (v) => {
    const updatedDiagnosis = data?.diagnosis?.filter(({ name }) => name !== v);
    handleChange("diagnosis", updatedDiagnosis);
  };

  const handleRemoveAllergy = (i) => {
    const updatedAllergies = data?.allergies?.filter((_, index) => index !== i);
    handleChange("allergies", updatedAllergies);
  };

  const handleAddAllergy = () => {
    handleChange("allergies", [...data?.allergies, allergyValue]);
    setAllergyValue("");
    allergyPopoverClose();
  };

  return (
    <Box className={classes.clientDataContent}>
      <Accordion
        className={classes.accordionStyle}
        chevron={<IconChevronDown />}
        chevronPosition="right"
        chevronSize={20}
        variant="separated"
        multiple
        defaultValue={["clientIntakeData", "clientEmergencyContactData"]}
      >
        <Accordion.Item key="clientIntakeData" value="clientIntakeData">
          <Accordion.Control>Intake Data</Accordion.Control>
          <Accordion.Panel>
            <Grid gutter={17}>
              {/* Name */}
              <Grid.Col span={12} md={3}>
                <TextInput
                  label="First Name"
                  placeholder="Enter Outcome Title"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.firstName || ""}
                  onChange={(e) => handleChange("firstName", e.target.value)}
                  error={errors?.firstName}
                />
              </Grid.Col>
              <Grid.Col span={12} md={3}>
                <TextInput
                  label="Last Name"
                  placeholder="Enter Last Name"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.lastName || ""}
                  onChange={(e) => handleChange("lastName", e.target.value)}
                  error={errors?.lastName}
                />
              </Grid.Col>

              {/* Admission Date */}
              <Grid.Col span={12} md={3}>
                <DateInput
                  label="Admission Date"
                  placeholder="mm/dd/yyyy"
                  valueFormat="MMM D, YYYY"
                  className={classes.inputStyle}
                  disabled={view}
                  value={
                    data.admissionDate
                      ? moment(data.admissionDate).toDate()
                      : null
                  }
                  onChange={(value) => handleChange("admissionDate", value)}
                  icon={<IoCalendarClearOutline />}
                  error={errors?.admissionDate}
                />
              </Grid.Col>

              {/* Assessment Type */}
              <Grid.Col span={12} md={3}>
                <TextInput
                  label="Assessment Type"
                  placeholder="Enter Assessment Type"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.assessmentType}
                  onChange={(e) =>
                    handleChange("assessmentType", e.target.value)
                  }
                  error={errors?.assessmentType}
                />
              </Grid.Col>

              {/* Date of Birth */}
              <Grid.Col span={12} md={3}>
                <DateInput
                  label="Date of Birth"
                  placeholder="mm/dd/yyyy"
                  valueFormat="MMM D, YYYY"
                  className={classes.inputStyle}
                  disabled={view}
                  value={
                    data.dateOfBirth ? moment(data.dateOfBirth).toDate() : null
                  }
                  onChange={(value) => handleChange("dateOfBirth", value)}
                  icon={<IoCalendarClearOutline />}
                  error={errors?.dateOfBirth}
                />
              </Grid.Col>

              {/* Code Status */}
              <Grid.Col span={12} md={3}>
                <TextInput
                  label="Code Status"
                  placeholder="Enter Code Status"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.codeStatus}
                  onChange={(e) => handleChange("codeStatus", e.target.value)}
                  error={errors?.codeStatus}
                />
              </Grid.Col>

              {/* Level of Care */}
              <Grid.Col span={12} md={3}>
                <Select
                  searchable
                  label="Level of Care"
                  data={careLevelOptions}
                  placeholder="Select Level of Care"
                  disabled={view}
                  className={classes.inputStyle}
                  value={data.levelOfCare}
                  onChange={(v) => handleChange("levelOfCare", v)}
                  error={errors?.levelOfCare}
                  rightSection={<ChevronIcon />}
                />
              </Grid.Col>

              {/* Date next TB screening */}
              <Grid.Col span={12} md={3}>
                <DateInput
                  label="Date of last TB Screening"
                  placeholder="mm/dd/yyyy"
                  valueFormat="MMM D, YYYY"
                  className={classes.inputStyle}
                  disabled={view}
                  value={
                    data.dateOfLastTBScreening
                      ? moment(data.dateOfLastTBScreening).toDate()
                      : null
                  }
                  onChange={(value) =>
                    handleChange("dateOfLastTBScreening", value)
                  }
                  icon={<IoCalendarClearOutline />}
                  error={errors?.dateOfLastTBScreening}
                />
              </Grid.Col>
              {/* Weight (lbs) */}
              <Grid.Col span={12} md={3}>
                <TextInput
                  label="Weight (lbs)"
                  placeholder="Enter Weight (lbs)"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.weightLbs}
                  onChange={(value) => handleChange("weightLbs", value)}
                  error={errors?.weightLbs}
                />
              </Grid.Col>

              {/* Blood Pressure */}
              <Grid.Col span={12} md={3}>
                <TextInput
                  label="Blood Pressure"
                  placeholder="Enter Blood Pressure"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.bloodPressure}
                  onChange={(e) =>
                    handleChange("bloodPressure", e.target.value)
                  }
                  error={errors?.bloodPressure}
                />
              </Grid.Col>

              {/* Pulse */}
              <Grid.Col span={12} md={3}>
                <TextInput
                  label="Pulse"
                  placeholder="Enter Pulse value"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.pulse}
                  onChange={(e) => handleChange("pulse", e.target.value)}
                  error={errors?.pulse}
                />
              </Grid.Col>

              {/* Oxygen */}
              <Grid.Col span={12} md={3}>
                <TextInput
                  label="Oxygen"
                  placeholder="Enter Oxygen value"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.oxygen}
                  onChange={(e) => handleChange("oxygen", e.target.value)}
                  error={errors?.oxygen}
                />
              </Grid.Col>

              {/* Respiration */}
              <Grid.Col span={12} md={3}>
                <TextInput
                  label="Respiration"
                  placeholder="Enter Respiration value"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.respiration}
                  onChange={(e) => handleChange("respiration", e.target.value)}
                  error={errors?.respiration}
                />
              </Grid.Col>

              {/* Temperature */}
              <Grid.Col span={12} md={3}>
                <TextInput
                  label="Temperature"
                  placeholder="Enter Temperature value"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.temperature}
                  onChange={(e) => handleChange("temperature", e.target.value)}
                  error={errors?.temperature}
                />
              </Grid.Col>

              {/* Glucose Check */}
              <Grid.Col span={12} md={3}>
                <TextInput
                  label="Glucose Check"
                  placeholder="Enter Glucose Check"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.glucoseCheck}
                  onChange={(e) => handleChange("glucoseCheck", e.target.value)}
                  error={errors?.glucoseCheck}
                />
              </Grid.Col>

              {/* Frequency */}
              <Grid.Col span={12} md={3}>
                <TextInput
                  label="Glucose Check Frequency"
                  placeholder="Enter Frequency"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.frequency}
                  onChange={(e) => handleChange("frequency", e.target.value)}
                  error={errors?.frequency}
                />
              </Grid.Col>

              {/* Diagnosis */}
              <Grid.Col span={12}>
                {/* <Textarea
                  label="Diagnosis"
                  placeholder="Add Diagnosis"
                  className={classes.input}
                  disabled={view}
                  minRows={4}
                  value={data.diagnosis}
                  onChange={(e) => handleChange("diagnosis", e.target.value)}
                  error={errors?.diagnosis}
                /> */}
                <Box>
                  <Flex className={classes.diagnosisBoxLabel}>
                    Diagnosis
                    <Popover
                      opened={diagPopoverOpened}
                      onChange={(o) =>
                        o ? diagPopoverOpen() : diagPopoverClose()
                      }
                      position="right-start"
                      withArrow
                      shadow="md"
                    >
                      <Popover.Target>
                        <ActionIcon
                          className={classes.inc_dec_Btn}
                          variant="white"
                          disabled={view}
                          onClick={() =>
                            diagPopoverOpened
                              ? diagPopoverClose()
                              : diagPopoverOpen()
                          }
                        >
                          <FaPlus size={15} color="#000" />
                        </ActionIcon>
                      </Popover.Target>
                      <Popover.Dropdown>
                        <Paper style={{ width: 260 }}>
                          <BillingSearchBar
                            placeholder="Search diagnos name..."
                            data={(alldiagnosiscode &&
                            alldiagnosiscode.diagnosiscode &&
                            diagnosisSearchValue
                              ? alldiagnosiscode.diagnosiscode
                              : []
                            ).map((item) => ({
                              value: item,
                              label: item?.shortdescription,
                              key: item?.code,
                            }))}
                            onChange={(item) => {
                              typeof item === "string" &&
                                item &&
                                getdiagnosiscode(item);
                              setDiagnosisField({
                                code: item?.code,
                                name: item?.shortdescription,
                              });
                            }}
                            value={
                              typeof diagnosisSearchValue === "string"
                                ? diagnosisSearchValue
                                : diagnosisSearchValue?.shortdescription
                            }
                            setValue={setDiagnosisSearchValue}
                          />

                          <Stack gap="sm">
                            <TextInput
                              label="Diagnosis Name"
                              placeholder="Add Diagnosis Name"
                              readOnly
                              size="sm"
                              value={diagnosisField?.name}
                            />

                            <TextInput
                              label="Diagnosis ID"
                              placeholder="Add Diagnosis ID"
                              readOnly
                              size="sm"
                              value={diagnosisField?.code}
                            />

                            <Button
                              type="button"
                              c={"#FFF"}
                              onClick={() => handleChangeDiagnosis()}
                              variant="fixed"
                              bg={"black"}
                              size="sm"
                              w={"100%"}
                            >
                              + Add
                            </Button>
                          </Stack>
                        </Paper>
                      </Popover.Dropdown>
                    </Popover>
                  </Flex>
                  <Box className={classes.diagnosisBox}>
                    <Flex className={classes.diagnosisBoxItemsFlex}>
                      {data?.diagnosis?.map(({ name, index }) => (
                        <Flex key={index} className={classes.diagnosisBoxItem}>
                          <p>{name}</p>
                          {!view && (
                            <ActionIcon
                            variant="white"
                            
                            onClick={() => handleRemoveDiagnosis(name)}
                            >
                            <IoIosClose />
                          </ActionIcon>
                          )}
                        </Flex>
                      ))}
                    </Flex>
                  </Box>
                </Box>
              </Grid.Col>

              {/* Allergies */}
              <Grid.Col span={12}>
                {/* <Textarea
                  label="Allergies"
                  placeholder="Add Diagnosis"
                  className={classes.input}
                  disabled={view}
                  minRows={4}
                  value={data.allergies}
                  onChange={(e) => handleChange("allergies", e.target.value)}
                  error={errors?.allergies}
                /> */}
                <Box>
                  <Flex className={classes.diagnosisBoxLabel}>
                    Allergies
                    <Popover
                      opened={allergyPopoverOpened}
                      onChange={(o) =>
                        o ? allergyPopoverOpen() : allergyPopoverClose()
                      }
                      position="right-start"
                      withArrow
                      shadow="md"
                    >
                      <Popover.Target>
                          <ActionIcon
                          className={classes.inc_dec_Btn}
                          variant="white"
                          disabled={view}
                          onClick={() =>
                            allergyPopoverOpened
                            ? allergyPopoverClose()
                            : allergyPopoverOpen()
                          }
                          >
                          <FaPlus size={15} color="#000" />
                        </ActionIcon>
                      </Popover.Target>
                      <Popover.Dropdown>
                        <Paper style={{ width: 260 }}>
                          <Stack gap="sm">
                            <TextInput
                              label="Allergy"
                              placeholder="Add Allergy"
                              size="sm"
                              value={allergyValue}
                              onChange={(e) =>
                                setAllergyValue(e?.target?.value)
                              }
                            />
                            <Button
                              type="button"
                              c={"#FFF"}
                              onClick={handleAddAllergy}
                              variant="fixed"
                              bg={"black"}
                              size="sm"
                              w={"100%"}
                              disabled={!allergyValue?.trim()}
                            >
                              + Add
                            </Button>
                          </Stack>
                        </Paper>
                      </Popover.Dropdown>
                    </Popover>
                  </Flex>
                  <Box className={classes.diagnosisBox}>
                    <Flex className={classes.diagnosisBoxItemsFlex}>
                      {data?.allergies?.map((txt, i) => (
                        <Flex className={classes.diagnosisBoxItem}>
                          <p>{txt}</p>
                           {!view && (
                             <ActionIcon variant="white">
                            <IoIosClose
                              onClick={() => handleRemoveAllergy(i)}
                              />
                          </ActionIcon>
                            )}
                        </Flex>
                      ))}
                    </Flex>
                  </Box>
                </Box>
              </Grid.Col>

              {/* Other/Past History */}
              <Grid.Col span={12}>
                <Textarea
                  label="Other/Past History"
                  placeholder="Enter Other/Past History"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data?.otherHistory || ""}
                  onChange={(e) => handleChange("otherHistory", e.target.value)}
                  error={errors?.otherHistory}
                />
              </Grid.Col>
            </Grid>
          </Accordion.Panel>
        </Accordion.Item>
        <Accordion.Item
          key="clientEmergencyContactData"
          value="clientEmergencyContactData"
        >
          <Accordion.Control>Emergency Contact</Accordion.Control>
          <Accordion.Panel>
            <Grid gutter={17}>
              <Grid.Col span={12} md={4}>
                <TextInput
                  label="POA Name"
                  placeholder="Enter POA Name"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data?.poaName || ""}
                  onChange={(e) => handleChange("poaName", e.target.value)}
                />
              </Grid.Col>

              <Grid.Col span={12} md={4}>
                <TextInput
                  label="Relationship"
                  placeholder="Enter Relationship"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data?.relationship || ""}
                  onChange={(e) => handleChange("relationship", e.target.value)}
                />
              </Grid.Col>

              <Grid.Col span={12} md={4}>
                <TextInput
                  label="Phone Number"
                  placeholder="Enter Number"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data?.poaPhone || ""}
                  onChange={(e) => handleChange("poaPhone", e.target.value)}
                />
              </Grid.Col>

              <Grid.Col span={12} md={4}>
                <TextInput
                  label="Primary Care Physician"
                  placeholder="Enter Primary Care Physician"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data?.primaryCarePhysician || ""}
                  onChange={(e) =>
                    handleChange("primaryCarePhysician", e.target.value)
                  }
                />
              </Grid.Col>

              <Grid.Col span={12} md={4}>
                <TextInput
                  label="Practice Name"
                  placeholder="Enter Practice Name"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.practiceName}
                  onChange={(e) => handleChange("practiceName", e.target.value)}
                />
              </Grid.Col>

              <Grid.Col span={12} md={4}>
                <TextInput
                  label="Phone Number"
                  placeholder="Enter Number"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.pcpPhone}
                  onChange={(e) => handleChange("pcpPhone", e.target.value)}
                />
              </Grid.Col>

              <Grid.Col span={12} md={6}>
                <TextInput
                  label="Pharmacy Name"
                  placeholder="Enter Pharmacy Name"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.pharmacyName}
                  onChange={(e) => handleChange("pharmacyName", e.target.value)}
                />
              </Grid.Col>

              <Grid.Col span={12} md={6}>
                <TextInput
                  label="Phone Number"
                  placeholder="Enter Number"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.pharmacyPhone}
                  onChange={(e) =>
                    handleChange("pharmacyPhone", e.target.value)
                  }
                />
              </Grid.Col>

              <Grid.Col span={12} md={4}>
                <TextInput
                  label="Home Health Agency"
                  placeholder="Enter Home Health Agency"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.homeHealthAgency}
                  onChange={(e) =>
                    handleChange("homeHealthAgency", e.target.value)
                  }
                />
              </Grid.Col>

              <Grid.Col span={12} md={4}>
                <TextInput
                  label="Services Received"
                  placeholder="Enter Services Received"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.servicesReceived}
                  onChange={(e) =>
                    handleChange("servicesReceived", e.target.value)
                  }
                />
              </Grid.Col>

              <Grid.Col span={12} md={4}>
                <TextInput
                  label="Phone Number"
                  placeholder="Enter Number"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.homeHealthAgencyPhone}
                  onChange={(e) =>
                    handleChange("homeHealthAgencyPhone", e.target.value)
                  }
                />
              </Grid.Col>

              <Grid.Col span={12} md={6}>
                <TextInput
                  label="Hospice Agency"
                  placeholder="Enter Hospice Agency"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.hospiceAgency}
                  onChange={(e) =>
                    handleChange("hospiceAgency", e.target.value)
                  }
                />
              </Grid.Col>

              <Grid.Col span={12} md={6}>
                <TextInput
                  label="Phone Number"
                  placeholder="Enter Number"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.hospicePhone}
                  onChange={(e) => handleChange("hospicePhone", e.target.value)}
                />
              </Grid.Col>

              <Grid.Col span={12}>
                <Textarea
                  label="Others"
                  placeholder="Add additional notes here"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.others}
                  onChange={(e) =>
                    handleChange("others", e.target.value)
                  }
                />
              </Grid.Col>
            </Grid>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Box>
  );
};

export default ClientDataStep;
